/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import firebase from "firebase/app";
import "firebase/firestore";
require("firebase/database");
export default {
  //---------------------------------------------------
  // GESTIONAR LA ESTACION MAS OPTIMA
  //---------------------------------------------------
  async GestionarEstacion({ commit, dispatch }, data) {
    commit("SET_LOADING2", true);
    //////console.log("--------------------------------------------------------------------------------")
    let estaciones = [];
    //////console.log("el tipo =>>>>>>>>>>>", data.tipo);
    let mallRef = firebase.database().ref("estacion");
    await mallRef.once("value", function(snapshot) {
      snapshot.forEach(function(childSnapshot) {
        let childKey = childSnapshot.key;
        let childData = childSnapshot.val();
        //////console.log(childData)
        //////console.log(data.id_mall)
        if (childData.id_mall == data.id_mall) {
          estaciones.push({ id: childKey, data: childData });
        }
      });
    });
    //////console.log("estaciones", estaciones);
    //buscar estacion más óptima x tipo
    //////console.log("buscando estacion mas optima...");
    let ingresoxestacion = [];
    // ////console.log("estaciones :", estaciones)
    ////console.log("obteniendo estaciones por tipo de entrega");
    for (let index = 0; index < estaciones.length; index++) {
      let ingresoxestacionRef = firebase.database().ref("ingresoxestacion");
      await ingresoxestacionRef.once("value", function(snapshot) {
        snapshot.forEach(function(childSnapshot) {
          let childKey = childSnapshot.key;
          let childData = childSnapshot.val();
          if (
            childData.id_estacion == estaciones[index].id &&
            childData.id_tipo == data.tipo
          ) {
            ingresoxestacion.push({ id: childKey, data: childData });
          }
        });
      });
    }
    ////console.log("el ingrteso por estacion:", ingresoxestacion);
    //////console.log("los ingresos por ingresoxestacion validos", ingresoxestacion);
    let aforoOptimo = 0;
    let id_ingresoxestacion = "";
    let id_estacion = "";
    let nombre_estacion = "";
    for (let index = 0; index < ingresoxestacion.length; index++) {
      let aforoxestacionxtipo = ingresoxestacion[index].data.aforo;
      //////console.log("aforo ", aforoxestacionxtipo)
      if (aforoxestacionxtipo >= aforoOptimo) {
        aforoOptimo = aforoxestacionxtipo;
        id_ingresoxestacion = ingresoxestacion[index].id;
        id_estacion = ingresoxestacion[index].data.id_estacion;
      }
    }
    //////console.log("el id de ingreso x estacion mas optimo es ", id_ingresoxestacion);
    //////console.log("guardando estacion...");
    let estacionRef = firebase.database().ref("estacion");
    await estacionRef.once("value", function(snapshot) {
      snapshot.forEach(function(childSnapshot) {
        let childKey = childSnapshot.key;
        let childData = childSnapshot.val();
        //////console.log(childData)
        //////console.log(data.id_mall)
        if (childKey == id_estacion) {
          nombre_estacion = childData.nombre;
        }
      });
    });
    commit("GET_ESTACION", {
      id_ingresoxestacion: id_ingresoxestacion,
      aforo: aforoOptimo,
      id_estacion: id_estacion,
      nombre_estacion: nombre_estacion
    });
    ////console.log("ejecuntado aforox dia");
    await dispatch("saveHorario");
  },
  //---------------------------------------------------
  // OBTENER EL AFORO X DIA
  //---------------------------------------------------
  async getAforoxDia({ state, commit }) {
    let id_ingresoxestacion = state.estacion.id_ingresoxestacion;
    let ActualAforoxdia = [];
    let aforoxdiaRef = firebase.database().ref("aforoxdia");
    await aforoxdiaRef.once("value", function(snapshot) {
      snapshot.forEach(function(childSnapshot) {
        let childKey = childSnapshot.key;
        let childData = childSnapshot.val();
        //////console.log(childData)
        //////console.log(data.id_mall)
        if (childData.id_ingresoxestacion == id_ingresoxestacion) {
          ActualAforoxdia.push({ id: childKey, data: childData });
        }
      });
    });
    commit("GET_AFOROXDIA", ActualAforoxdia);
  },
  //---------------------------------------------------
  // OBTENER EL AFORO X HORA
  //---------------------------------------------------
  async getAforoxhora({ commit, dispatch, state }) {
    await dispatch("getAforoxDia");
    let ActualAforoxdia = state.aforoxdia;
    //console.log("aforx dia asctual", ActualAforoxdia)
    let aforoxdiaRef = firebase.database().ref("aforoxhora");
    let horarioAux = [];
    ////console.log("el array aforoactual por cada dia es", ActualAforoxdia);
    ////console.log("tamñano de ActualAforoxdia", ActualAforoxdia.length);
    for (let index = 0; index < ActualAforoxdia.length; index++) {
      await aforoxdiaRef.once("value", function(snapshot) {
        snapshot.forEach(function(childSnapshot) {
          let childKey = childSnapshot.key;
          let childData = childSnapshot.val();
          //////console.log(data.id_mall)
          if (ActualAforoxdia[index].id == childData.id_aforoxdia) {
            //console.log(childData.id_aforoxdia);
            horarioAux.push({ id: childKey, data: childData });
          }
        });
      });
    }
    //console.log("aforxhora",horarioAux);
    commit("GET_AFOROXHORA", horarioAux);
  },

  //---------------------------------------------------
  // ACTUALIZAR LAS FECHAS
  //---------------------------------------------------
  async updatedia({ commit }) {
    let fecha = new Date();
    let yearActual = fecha.getFullYear();
    let mesActual = fecha.getMonth() + 1;
    let dia = fecha.getDate();
    let diasxmes = [];
    let diasxmesActual = [];
    let existeEldia = false;
    let nrodias = new Date(
      fecha.getFullYear(),
      fecha.getMonth() + 1,
      0
    ).getDate();
    //console.log("mes ", yearActual.toString());
    if (dia == nrodias) {
      dia = 0;
      mesActual = fecha.getMonth() + 2;
      nrodias = new Date(fecha.getFullYear(), mesActual, 0).getDate();
    }
    //console.log("nuevo mes ", yearActual.toString());
    //console.log("numero de dias00", nrodias);
    for (let index = 1; index <= nrodias; index++) {
      diasxmes.push(index);
    }
    let count2 = 0;
    ////console.log("dia", dia);
    for (let index = 0; index <= nrodias; index++) {
      if (index > dia && count2 < 4) {
        diasxmesActual.push(index);
        count2++;
      }
    }
    //console.log("Calculando los dias siguientes");
    //console.log("los dias siguientes son :", diasxmesActual);
    var aforoxdia2 = [];
    let childKey = "";
    let childData = "";
    let dia5 = (dia + 4)
      .toString()
      .concat(
        "-",
        mesActual.toString(),
        "-",
        yearActual.toString().substring(2)
      );
    //console.log("dia 5 ", dia5);
    let aforoxdiaRef = firebase.database().ref("aforoxdia");
    await aforoxdiaRef.once("value", function(snapshot) {
      snapshot.forEach(function(childSnapshot) {
        childKey = childSnapshot.key;
        childData = childSnapshot.val();
        aforoxdia2.push({ id: childKey, data: childData });
        if (childData.dias == dia5) {
          existeEldia = true;
        }
      });
    });
    //console.log("se encontro el dia", existeEldia);
    //console.log("aforo por dia", aforoxdia2);
    //console.log("tamaño aforo por dia", aforoxdia2.length);
    let count = 0;
    for (let index = 0; index < aforoxdia2.length; index++) {
      if (count === 4) {
        count = 0;
      }
      let x = diasxmesActual[count];
      let y = x;

      let yearActuals = yearActual.toString();
      aforoxdia2[index].data.dias = `${y}-${mesActual}-${yearActuals.substring(
        2
      )}`;
      count++;
    }
    // ////console.log("el nuevo aforo", aforoxdia2);
    if (!existeEldia) {
      ////console.log(aforoxdia2.length)
      for (let index = 0; index < aforoxdia2.length; index++) {
        let id = aforoxdia2[index].id;
        //////console.log("ID", id, "DATA",aforoxdia2[index].data)
        firebase
          .database()
          .ref("aforoxdia/" + id)
          .set(aforoxdia2[index].data);
      }
      //console.log("[CONCLUSION] => Se actualizaron las fechas");
    } else {
      //console.log("[CONCLUSION] => No se actualizaron las fechas");
    }
  },
  //-----------------------------------------------
  // EXISTE DIA [NO INTERACCIONA]
  //-----------------------------------------------
  existeDiaHoy() {
    let dias = [];
    let fecha = new Date();
    let yearActual = fecha
      .getFullYear()
      .toString()
      .substring(2);
    let mesActual = fecha.getMonth() + 1;
    let dia = fecha.getDay();
    let hoy = dia.concat("-", mesActual, "-", yearActual);
    const diasRef = firebase.database().ref("dias");
    diasRef.on("value", function(snapshot) {
      snapshot.forEach(function(childSnapshot) {
        let childKey = childSnapshot.key;
        let childData = childSnapshot.val();
        dias.push({ id: childKey, data: childData });
      });
    });
    for (let index = 0; index < dias.length; index++) {
      if (dias[index].data.nombre === hoy) {
        return true;
      }
    }
  },
  //-----------------------------------------------
  // [NO INTERACCIONA]
  //-----------------------------------------------
  updateDias() {
    if (!this.existeDiaHoy) {
      let fecha = new Date();
      let yearActual = fecha
        .getFullYear()
        .toString()
        .substring(2);
      let mesActual = fecha.getMonth() + 1;
      9;
      let dia = fecha.getDay();
      let hoy = dia.concat("-", mesActual, "-", yearActual);
      firebase
        .database()
        .ref("dias")
        .set({ nombre: hoy, tipo01: 30, tipo02: 10 });
    }
  },
  //-----------------------------------------------
  // AFORO X HORA
  //-----------------------------------------------
  //   async aforoxh({ commit }) {
  //     let aforoxdia = [];
  //     let horario = [];
  //     let aforoxhora = [];
  //     var aforoxdiaRef = firebase.database().ref("aforoxdia");
  //     await aforoxdiaRef.once("value", function(snapshot) {
  //       snapshot.forEach(function(childSnapshot) {
  //         let childKey = childSnapshot.key;
  //         let childData = childSnapshot.val();
  //         aforoxdia.push({ id: childKey, data: childData });
  //       });
  //     });
  //     var horarioRef = firebase.database().ref("horario");
  //     await horarioRef.once("value", function(snapshot) {
  //       snapshot.forEach(function(childSnapshot) {
  //         let childKey = childSnapshot.key;
  //         let childData = childSnapshot.val();
  //         horario.push({ id: childKey, data: childData });
  //       });
  //     });
  //     //////console.log(aforoxdia.length);
  //     //////console.log("los aforoxdia", aforoxdia);
  //     //////console.log("los horarios", horario);
  //     //////console.log(JSON.stringify(aforoxdia));
  //     //////console.log(JSON.stringify(horario));
  //     //////console.log(horario.length);
  //     for (let index = 0; index < aforoxdia.length; index++) {
  //       let id_dia = aforoxdia[index].id;
  //       ////console.log("id_dia", id_dia);
  //       ////console.log("dentro del primer for ");
  //       for (let index2 = 0; index2 < horario.length; index2++) {
  //         //////console.log("id_aforoxdia", id_dia);
  //         aforoxhora.push({ id_aforoxdia :id_dia, id_horario:horario[index2].id});
  //         // ////console.log("contador",index);
  //       }
  //     }
  //     // ////console.log("el aforo xd hora es: ",aforoxhora )
  //     firebase.database().ref('aforoxhora').set(aforoxhora);
  //     commit("GET_AFOROXHORA", aforoxhora);
  // },
  //-----------------------------------------------
  //   [NO INTERACCIONA]
  //-----------------------------------------------
  updateaforoxdia() {},
  async getCalendario({ commit }) {
    const aux = [];
    await firebase
      .firestore()
      .collection("horarios")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          aux.push({ id: doc.id, data: doc.data() });
        });
      });
    commit("GET_CALENDARIO", aux);
  },
  //-----------------------------------------------
  //  OBTENIENDO HORARIOS
  //-----------------------------------------------

  async getHorarios({ commit }) {
    let horarios = [];
    let aforoxdiaRef = firebase.database().ref("horario");
    await aforoxdiaRef.once("value", function(snapshot) {
      snapshot.forEach(function(childSnapshot) {
        let childKey = childSnapshot.key;
        let childData = childSnapshot.val();
        horarios.push({ id: childKey, data: childData });
      });
    });
    ////console.log("los horarios son ", horarios);
    commit("GET_HORARIO", horarios);
  },
  //-----------------------------------------------
  //  [NO INTERACCIONA]
  //-----------------------------------------------
  async getcalendario({ commit }, data) {
    const aux = [];
    var starCountRef = firebase.database().ref("aforo_diario");
    starCountRef.on("value", function(snapshot) {
      snapshot.forEach(function(childSnapshot) {
        let childKey = childSnapshot.key;
        let childData = childSnapshot.val();
        aux.push({ id: childKey, data: childData });
      });
      const calendario = aux.find(
        aforoxdia =>
          aforoxdia.data.id_mall === data.id_mall &&
          aforoxdia.data.id_estacion === data.id_estacion
      );
      ////console.log("la data recibida es aforx dia es  ", calendario);
      commit("GET_CALENDARIO", calendario);
    });
  },
  //-----------------------------------------------
  // OBTENER EL PEDIDO
  //-----------------------------------------------
  async getPedido({ commit, dispatch }, id_pedido) {
    let aux = [];
    var starCountRef = firebase.database().ref("pedido/" + id_pedido);
    await starCountRef.once("value", function(snapshot) {
      aux = snapshot.val();
    });
    // DateTimeFormatter outputFormatter = DateTimeFormatter.ofPattern("dd-MM-yyy", Locale.ENGLISH)
    // LocalDate date = LocalDate.parse("2018-04-10T04:00:00.000Z", inputFormatter)
    let fecha = aux.fecha;
    const jsDate = new Date(fecha); // Convert to JavaScript `Date` object
    var options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric"
    };

    ////console.log("tipo den nrp ´peddi", typeof aux.nro_pedido);
    aux.fecha = jsDate.toLocaleDateString("es-US", options);
    commit("GET_PEDIDO", aux);
    dispatch("estado_Reserva");
  },
  //-----------------------------------------------
  // OBTENER EL DIA SELECCIONADO POR EL USUARIO
  //-----------------------------------------------
  diaSeleccionado({ commit }, data) {
    commit("GET_FECHA_SELECCIONADO", data.fecha);
    commit("GET_DIA_SELECCIONADO", data.dia);
    commit("GET_HORA_SELECCIONADO", data.hora);
    commit("GET_ID_SELECCIONADO", data.id);
    commit("GET_ID_AFOROXDIA_SELECCIONADO", data.id_aforoxdia);
    commit("GET_ID_HORA_SELECCIONADO", data.id_hora);
  },
  async reserva({ commit, state }, data) {
    ////console.log("la data", data);
    console.log("tipo de entrega en el action ", data.tipo_entrega);
    var starCountRef = firebase.database().ref("reserva/" + data.id_pedido);
    starCountRef
      .set({
        id_pedido: data.id_pedido,
        nombre: data.nombre,
        apell_usuario: data.apell_usuario,
        estacion: data.estacion,
        id_mall: data.id_mall,
        dia: data.dia,
        producto: data.producto,
        estado: true,
        tipo_entrega: data.tipo_entrega,
        aforoxhora: data.id.id,
        hora: data.hora,
        id_horario: state.id_hora
      })
      .then(async function() {
        if (state.id_old.length !== 0) {
          let aforo = "";
          let horario = "";
          let aforxdia = "";
          let aforoxdiaRef = firebase.database().ref("aforoxhora");
          await aforoxdiaRef.once("value", function(snapshot) {
            snapshot.forEach(function(childSnapshot) {
              let childKey = childSnapshot.key;
              let childData = childSnapshot.val();
              if (state.id_old.data.aforoxhora == childKey) {
                aforo = childData.aforo;
                horario = childData.id_horario;
                aforxdia = childData.id_aforoxdia;
              }
            });
          });
          //console.log("horario antigu", horario);
          //console.log("ANTIGUIO EL AFORO ES ", aforo);
          var starCountRef2 = firebase
            .database()
            .ref("aforoxhora/" + state.id_old.data.aforoxhora);
          //console.log("id aforoxhora antiguo", state.id_old.data.aforoxhora);
          starCountRef2
            .set({
              aforo: (parseInt(aforo) + 1).toString(),
              id_aforoxdia: aforxdia,
              id_horario: horario
            })
            .then(function() {
              //console.log("aforo antiguo  id_horario ", state.id_old.data.id_horario);
              //console.log("aforo antiguo  actualizado ", state.id_old.id);
            })
            .catch(function(error) {
              console.error("Errror al actualizar el aforo antiguo : ", error);
            });

          //console.log("SE ACTUALIZO ANTIGUO AFORO : ");
        }
        var starCountRef = firebase.database().ref("aforoxhora/" + data.id.id);
        console.log("estrado aforo x dia", state.id_aforoxdia);
        starCountRef
          .set({
            aforo: (parseInt(data.id.aforo) - 1).toString(),
            id_aforoxdia: state.id_aforoxdia,
            id_horario: data.id.id_horario
          })
          .then(function() {
            console.log("aforo actualizado ", data.id.id);
          })
          .catch(function(error) {
            console.error("Errror al actualizar el aforo: ", error);
          });
        ////console.log("Document written with ID: ");
        commit("GET_ID_SELECCIONADO_OLD", { data: data });
        commit("RESERVA_EXISTE", true);
      })
      .catch(function(error) {
        console.error("Error adding document: ", error);
      });
  },
  //--------------------------------------------------
  // GUARDAR HORARIO
  //---------------------------------------------------
  async saveHorario({ dispatch, commit, state }) {
    await dispatch("getAforoxhora");
    let horario = state.aforoxhora;
    //console.log("save horario", horario);
    //console.log("tamaño ", horario.length);
    let horarioFormateado = [];
    let dia1 = [];
    let dia2 = [];
    let dia3 = [];
    let dia4 = [];
    for (let index = 0; index < horario.length; index++) {
      if (index <= 6) {
        dia1.push({
          aforo: horario[index].data.aforo,
          id_horario: horario[index].data.id_horario,
          id: horario[index].id
        });
      } else if (index > 6 && index <= 13) {
        dia2.push({
          aforo: horario[index].data.aforo,
          id_horario: horario[index].data.id_horario,
          id: horario[index].id
        });
      } else if (index > 13 && index <= 20) {
        dia3.push({
          aforo: horario[index].data.aforo,
          id_horario: horario[index].data.id_horario,
          id: horario[index].id
        });
      } else if (index > 20 && index <= 27) {
        dia4.push({
          aforo: horario[index].data.aforo,
          id_horario: horario[index].data.id_horario,
          id: horario[index].id
        });
      }
    }
    horarioFormateado[0] = { dia1: 1, data: dia1 };
    horarioFormateado[1] = { dia2: 2, data: dia2 };
    horarioFormateado[2] = { dia3: 3, data: dia3 };
    horarioFormateado[3] = { dia4: 4, data: dia4 };
    //console.log("hoario formateado es", horarioFormateado);
    commit("GET_DIA_DETALLE", horarioFormateado);
    commit("SET_LOADING2", false);
  },
  //--------------------------------------------------
  // VERFIFICAR ESTADO DE RESERVA
  //---------------------------------------------------
  async estado_Reserva({ state, commit }) {
    let id_pedido = state.pedido.id_pedido;
    let existe = false;
    let id_aforoxhora = "";
    ////console.log("existae la reserva? ,", id_pedido);
    let aforoxdiaRef = firebase.database().ref("reserva");
    await aforoxdiaRef.once("value", function(snapshot) {
      snapshot.forEach(function(childSnapshot) {
        let childKey = childSnapshot.key;
        let childData = childSnapshot.val();
        //////console.log(childData)
        //////console.log(data.id_mall)
        if (id_pedido == childKey) {
          existe = true;
          id_aforoxhora = { id: childKey, data: childData };
        }
      });
    });
    ////console.log(id_aforoxhora)
    ////console.log("resultado exites?", existe);
    commit("RESERVA_EXISTE", existe);
    commit("GET_ID_SELECCIONADO_OLD", id_aforoxhora);
  },
  modificarReserva() {}
};
